module.exports = __webpack_public_path__ + "img/architecture.0c5de2f7.svg";